import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Currency, Grid } from '../../../../../ui-toolkit';

export const StyledKabobIcon = styled(FontAwesomeIcon)`
  padding-left: ${(props) => props.theme.spacing.roomyContentPaddingValue}px;
  padding-right: ${(props) => props.theme.spacing.roomyContentPaddingValue}px;
`;

export const StyledDetail = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledDetailsGrid = styled(Grid)`
  padding: ${(props) => props.theme.spacing.spacing5};
  border-top: 1px solid ${(props) => props.theme.colors.gray};
  .o-grid:not(:has(*)) {
    display: none;
  }
`;

export const StyledCurrency = styled(Currency)`
  ${(props) => props.theme.fonts.mixins.boldBody}
  ${(props) => props.theme.fonts.mixins.header3}
`;
export const StyledIncomingTableRow = styled.div<{ columnsLength: number; isTotalsRow?: boolean; alignTop?: boolean }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.columnsLength - 1}, 1fr) 20px;
  ${(props) => props.isTotalsRow && props.theme.fonts.semiBoldWeight};
  padding: ${(props) => props.theme.spacing.spacing5};
  gap: ${(props) => props.theme.spacing.spacing5};
  border-top: 1px solid ${(props) => props.theme.colors.gray};
  align-items: ${(props) => (props.alignTop ? 'top' : 'center')};
`;
